const darkColors = {
   // gradients (cards / headers / sections)
  primary: "linear-gradient(135deg,#1e1e2f,#232336)",
  secondary: "linear-gradient(135deg,#1a1a28,#202033)",

  // brand accent (golden premium)
  accent: "#e6b450",

  // borders & dividers
  border: "#2f2f45",

  // text colors
  // text: "#eaeaf0",
  text: "#b4b4b4",
  textSecondary: "#9aa0b4",

  // main background
  background: "#12121a",

  // hover background (subtle glow)
  hoverBg: "rgba(230, 180, 80, 0.12)",

  // ==========================
  // BUTTON COLORS
  // ==========================

  // primary buttons
  // button: "#2c2c3f",
  button: "#eeeeee",
  // hover_btn: "#3a3a55",
  hover_btn: "#e0e0e0",


  // deactivate button (danger – muted red)
  button_red_bg: "#c62828",
  hover_red_btn: "#8e0000",

  // activate button (success – classy green)
  button_green_bg: "#2e7d32",
  hover_green_btn: "#43a047",

  // edit button (cool blue)
  button_edit_bg: "#1565c0",
  hover_edit_btn: "#1e88e5",


  // #card colors
  cardBg:"linear-gradient(135deg,#1e1e2f,#232336)",
  card_chip_bg: "rgba(0,0,0,0.06)",
  card_txt_color: "#969696",
  card_img_bg:"rgba(230, 180, 80, 0.12)"

};

export default darkColors;
